import React from 'react';

import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';
import GenericModal from '@portal/components/GenericModal/GenericModal';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { translate } from '@portal/services/i18n';

type CardCodeModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cardCode: string;
  onCardCodeChange: (value: string) => void;
};

const CardCodeModal = ({
  visible,
  onClose,
  onConfirm,
  cardCode,
  onCardCodeChange,
}: CardCodeModalProps) => {
  return (
    <GenericModal
      visible={visible}
      title={translate(
        'PAGES.CARDS.MY_CARDS.DETAILS.UNBLOCK_CARD.FIRST_ACCESS.MODAL.CARD_CODE_TITLE'
      )}
      onClose={onClose}
      actions={[
        {
          label: translate(
            'PAGES.CARDS.MY_CARDS.DETAILS.UNBLOCK_CARD.FIRST_ACCESS.MODAL.CLOSE'
          ),
          onClick: onClose,
          variant: 'outlined',
        },
        {
          label: translate(
            'PAGES.CARDS.MY_CARDS.DETAILS.UNBLOCK_CARD.FIRST_ACCESS.MODAL.CONFIRM'
          ),
          onClick: onConfirm,
          variant: 'primary',
          disabled: !cardCode.trim(),
        },
      ]}
    >
      <ThemedText variant="h4" className="typo-mb-md">
        {translate(
          'PAGES.CARDS.MY_CARDS.DETAILS.UNBLOCK_CARD.FIRST_ACCESS.MODAL.CARD_CODE_DESCRIPTION'
        )}
      </ThemedText>
      <AdvancedInput
        label={translate(
          'PAGES.CARDS.MY_CARDS.DETAILS.UNBLOCK_CARD.FIRST_ACCESS.MODAL.CARD_CODE_LABEL'
        )}
        value={cardCode}
        onChange={onCardCodeChange}
      />
    </GenericModal>
  );
};

export default CardCodeModal;
